import flattenMessages from '../flattenMessages';
import en from './en.json';
import es from './es.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: flattenMessages(en, 'decrypt'),
  es: flattenMessages(es, 'decrypt'),
  ru: flattenMessages(ru, 'decrypt'),
  zh: flattenMessages(zh, 'decrypt'),
};
